import classnames from 'classnames';
import { RetailerKpiOption } from '@models/Products';

export interface ButtonGroupButtonProps {
  title?: string;
  text?: string;
  id?: RetailerKpiOption;
  onClick: () => void;
}

interface ButtonGroupButtonAddtProps {
  isActive: boolean;
  disabled: boolean;
}

export const ButtonGroupButton: React.FC<ButtonGroupButtonProps & ButtonGroupButtonAddtProps> = ({
  title,
  text,
  onClick,
  isActive,
  disabled,
}) => {
  const cssClasses = classnames({
    ['items-center bg-light border border-light border-l-0 text-lighter inline-flex text-base p-2 relative transition-all hover:bg-white']: true,
    ['bg-white']: isActive,
    ['bg-light text-inactive hover:bg-light']: disabled,
  });
  const getTextColor = () => {
    if (disabled) {
      return '#6a757c';
    }
    return isActive ? '#cf4800' : '#6f7582';
  };

  return (
    <button className={`${cssClasses} z-index-default`} onClick={() => onClick()} title={title} disabled={disabled}>
      {text && <span style={{ color: getTextColor() }}>{text}</span>}
    </button>
  );
};
